function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*! For license information please see ckeditor.js.LICENSE.txt */

/*!*
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */
!function (t, n) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = n(require("react")) : "function" == typeof define && define.amd ? define(["react"], n) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.CKEditor = n(require("react")) : t.CKEditor = n(t.React);
}("undefined" != typeof self ? self : this, function (t) {
  return function (t) {
    var n = {};

    function r(e) {
      if (n[e]) return n[e].exports;
      var o = n[e] = {
        i: e,
        l: !1,
        exports: {}
      };
      return t[e].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = t, r.c = n, r.d = function (t, n, e) {
      r.o(t, n) || Object.defineProperty(t, n, {
        enumerable: !0,
        get: e
      });
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.t = function (t, n) {
      if (1 & n && (t = r(t)), 8 & n) return t;
      if (4 & n && "object" == _typeof(t) && t && t.__esModule) return t;
      var e = Object.create(null);
      if (r.r(e), Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
      }), 2 & n && "string" != typeof t) for (var o in t) {
        r.d(e, o, function (n) {
          return t[n];
        }.bind(null, o));
      }
      return e;
    }, r.n = function (t) {
      var n = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return r.d(n, "a", n), n;
    }, r.o = function (t, n) {
      return Object.prototype.hasOwnProperty.call(t, n);
    }, r.p = "", r(r.s = 41);
  }([function (t, n, r) {
    (function (n) {
      var r = function r(t) {
        return t && t.Math == Math && t;
      };

      t.exports = r("object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) && globalThis) || r("object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window) || r("object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self) || r("object" == _typeof(n) && n) || function () {
        return this;
      }() || Function("return this")();
    }).call(this, r(43));
  }, function (t, n) {
    t.exports = function (t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    };
  }, function (t, n, r) {
    t.exports = r(81)();
  }, function (t, n) {
    t.exports = function (t) {
      return "object" == _typeof(t) ? null !== t : "function" == typeof t;
    };
  }, function (t, n) {
    var r = {}.hasOwnProperty;

    t.exports = function (t, n) {
      return r.call(t, n);
    };
  }, function (t, n, r) {
    var e = r(0),
        o = r(12).f,
        i = r(7),
        c = r(46),
        u = r(19),
        a = r(49),
        f = r(56);

    t.exports = function (t, n) {
      var r,
          s,
          p,
          l,
          v,
          y = t.target,
          d = t.global,
          h = t.stat;
      if (r = d ? e : h ? e[y] || u(y, {}) : (e[y] || {}).prototype) for (s in n) {
        if (l = n[s], p = t.noTargetGet ? (v = o(r, s)) && v.value : r[s], !f(d ? s : y + (h ? "." : "#") + s, t.forced) && void 0 !== p) {
          if (_typeof(l) == _typeof(p)) continue;
          a(l, p);
        }

        (t.sham || p && p.sham) && i(l, "sham", !0), c(r, s, l, t);
      }
    };
  }, function (t, n, r) {
    var e = r(1);
    t.exports = !e(function () {
      return 7 != Object.defineProperty({}, 1, {
        get: function get() {
          return 7;
        }
      })[1];
    });
  }, function (t, n, r) {
    var e = r(6),
        o = r(10),
        i = r(13);
    t.exports = e ? function (t, n, r) {
      return o.f(t, n, i(1, r));
    } : function (t, n, r) {
      return t[n] = r, t;
    };
  }, function (t, n, r) {
    var e = r(16);

    t.exports = function (t) {
      return Object(e(t));
    };
  }, function (t, n, r) {
    var e = r(0),
        o = r(26),
        i = r(4),
        c = r(28),
        u = r(36),
        a = r(58),
        f = o("wks"),
        s = e.Symbol,
        p = a ? s : s && s.withoutSetter || c;

    t.exports = function (t) {
      return i(f, t) || (u && i(s, t) ? f[t] = s[t] : f[t] = p("Symbol." + t)), f[t];
    };
  }, function (t, n, r) {
    var e = r(6),
        o = r(23),
        i = r(18),
        c = r(17),
        u = Object.defineProperty;
    n.f = e ? u : function (t, n, r) {
      if (i(t), n = c(n, !0), i(r), o) try {
        return u(t, n, r);
      } catch (t) {}
      if ("get" in r || "set" in r) throw TypeError("Accessors not supported");
      return "value" in r && (t[n] = r.value), t;
    };
  }, function (t, n, r) {
    var e = r(32),
        o = Math.min;

    t.exports = function (t) {
      return t > 0 ? o(e(t), 9007199254740991) : 0;
    };
  }, function (t, n, r) {
    var e = r(6),
        o = r(44),
        i = r(13),
        c = r(14),
        u = r(17),
        a = r(4),
        f = r(23),
        s = Object.getOwnPropertyDescriptor;
    n.f = e ? s : function (t, n) {
      if (t = c(t), n = u(n, !0), f) try {
        return s(t, n);
      } catch (t) {}
      if (a(t, n)) return i(!o.f.call(t, n), t[n]);
    };
  }, function (t, n) {
    t.exports = function (t, n) {
      return {
        enumerable: !(1 & t),
        configurable: !(2 & t),
        writable: !(4 & t),
        value: n
      };
    };
  }, function (t, n, r) {
    var e = r(22),
        o = r(16);

    t.exports = function (t) {
      return e(o(t));
    };
  }, function (t, n) {
    var r = {}.toString;

    t.exports = function (t) {
      return r.call(t).slice(8, -1);
    };
  }, function (t, n) {
    t.exports = function (t) {
      if (null == t) throw TypeError("Can't call method on " + t);
      return t;
    };
  }, function (t, n, r) {
    var e = r(3);

    t.exports = function (t, n) {
      if (!e(t)) return t;
      var r, o;
      if (n && "function" == typeof (r = t.toString) && !e(o = r.call(t))) return o;
      if ("function" == typeof (r = t.valueOf) && !e(o = r.call(t))) return o;
      if (!n && "function" == typeof (r = t.toString) && !e(o = r.call(t))) return o;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (t, n, r) {
    var e = r(3);

    t.exports = function (t) {
      if (!e(t)) throw TypeError(String(t) + " is not an object");
      return t;
    };
  }, function (t, n, r) {
    var e = r(0),
        o = r(7);

    t.exports = function (t, n) {
      try {
        o(e, t, n);
      } catch (r) {
        e[t] = n;
      }

      return n;
    };
  }, function (t, n, r) {
    var e = r(0),
        o = r(19),
        i = "__core-js_shared__",
        c = e[i] || o(i, {});
    t.exports = c;
  }, function (n, r) {
    n.exports = t;
  }, function (t, n, r) {
    var e = r(1),
        o = r(15),
        i = "".split;
    t.exports = e(function () {
      return !Object("z").propertyIsEnumerable(0);
    }) ? function (t) {
      return "String" == o(t) ? i.call(t, "") : Object(t);
    } : Object;
  }, function (t, n, r) {
    var e = r(6),
        o = r(1),
        i = r(45);
    t.exports = !e && !o(function () {
      return 7 != Object.defineProperty(i("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, n, r) {
    var e = r(20),
        o = Function.toString;
    "function" != typeof e.inspectSource && (e.inspectSource = function (t) {
      return o.call(t);
    }), t.exports = e.inspectSource;
  }, function (t, n, r) {
    var e = r(26),
        o = r(28),
        i = e("keys");

    t.exports = function (t) {
      return i[t] || (i[t] = o(t));
    };
  }, function (t, n, r) {
    var e = r(27),
        o = r(20);
    (t.exports = function (t, n) {
      return o[t] || (o[t] = void 0 !== n ? n : {});
    })("versions", []).push({
      version: "3.8.2",
      mode: e ? "pure" : "global",
      copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
    });
  }, function (t, n) {
    t.exports = !1;
  }, function (t, n) {
    var r = 0,
        e = Math.random();

    t.exports = function (t) {
      return "Symbol(" + String(void 0 === t ? "" : t) + ")_" + (++r + e).toString(36);
    };
  }, function (t, n) {
    t.exports = {};
  }, function (t, n, r) {
    var e = r(51),
        o = r(0),
        i = function i(t) {
      return "function" == typeof t ? t : void 0;
    };

    t.exports = function (t, n) {
      return arguments.length < 2 ? i(e[t]) || i(o[t]) : e[t] && e[t][n] || o[t] && o[t][n];
    };
  }, function (t, n, r) {
    var e = r(4),
        o = r(14),
        i = r(53).indexOf,
        c = r(29);

    t.exports = function (t, n) {
      var r,
          u = o(t),
          a = 0,
          f = [];

      for (r in u) {
        !e(c, r) && e(u, r) && f.push(r);
      }

      for (; n.length > a;) {
        e(u, r = n[a++]) && (~i(f, r) || f.push(r));
      }

      return f;
    };
  }, function (t, n) {
    var r = Math.ceil,
        e = Math.floor;

    t.exports = function (t) {
      return isNaN(t = +t) ? 0 : (t > 0 ? e : r)(t);
    };
  }, function (t, n) {
    t.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
  }, function (t, n, r) {
    var e = r(15);

    t.exports = Array.isArray || function (t) {
      return "Array" == e(t);
    };
  }, function (t, n, r) {
    var e = r(3),
        o = r(34),
        i = r(9)("species");

    t.exports = function (t, n) {
      var r;
      return o(t) && ("function" != typeof (r = t.constructor) || r !== Array && !o(r.prototype) ? e(r) && null === (r = r[i]) && (r = void 0) : r = void 0), new (void 0 === r ? Array : r)(0 === n ? 0 : n);
    };
  }, function (t, n, r) {
    var e = r(1);
    t.exports = !!Object.getOwnPropertySymbols && !e(function () {
      return !String(Symbol());
    });
  }, function (t, n, r) {
    var e,
        o,
        i = r(0),
        c = r(60),
        u = i.process,
        a = u && u.versions,
        f = a && a.v8;
    f ? o = (e = f.split("."))[0] + e[1] : c && (!(e = c.match(/Edge\/(\d+)/)) || e[1] >= 74) && (e = c.match(/Chrome\/(\d+)/)) && (o = e[1]), t.exports = o && +o;
  }, function (t, n, r) {
    "use strict";

    var e = r(62).forEach,
        o = r(65),
        i = r(66),
        c = o("forEach"),
        u = i("forEach");
    t.exports = c && u ? [].forEach : function (t) {
      return e(this, t, arguments.length > 1 ? arguments[1] : void 0);
    };
  }, function (t, n, r) {
    var e = r(1);
    t.exports = !e(function () {
      function t() {}

      return t.prototype.constructor = null, Object.getPrototypeOf(new t()) !== t.prototype;
    });
  }, function (t, n) {
    /*!*
     * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
     * For licensing, see LICENSE.md.
     */
    !function (t, n) {
      for (var r in n) {
        t[r] = n[r];
      }
    }(n, function (t) {
      var n = {};

      function r(e) {
        if (n[e]) return n[e].exports;
        var o = n[e] = {
          i: e,
          l: !1,
          exports: {}
        };
        return t[e].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
      }

      return r.m = t, r.c = n, r.d = function (t, n, e) {
        r.o(t, n) || Object.defineProperty(t, n, {
          enumerable: !0,
          get: e
        });
      }, r.r = function (t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(t, "__esModule", {
          value: !0
        });
      }, r.t = function (t, n) {
        if (1 & n && (t = r(t)), 8 & n) return t;
        if (4 & n && "object" == _typeof(t) && t && t.__esModule) return t;
        var e = Object.create(null);
        if (r.r(e), Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        }), 2 & n && "string" != typeof t) for (var o in t) {
          r.d(e, o, function (n) {
            return t[n];
          }.bind(null, o));
        }
        return e;
      }, r.n = function (t) {
        var n = t && t.__esModule ? function () {
          return t.default;
        } : function () {
          return t;
        };
        return r.d(n, "a", n), n;
      }, r.o = function (t, n) {
        return Object.prototype.hasOwnProperty.call(t, n);
      }, r.p = "", r(r.s = 83);
    }([function (t, n, r) {
      (function (n) {
        var r = function r(t) {
          return t && t.Math == Math && t;
        };

        t.exports = r("object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) && globalThis) || r("object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window) || r("object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self) || r("object" == _typeof(n) && n) || Function("return this")();
      }).call(this, r(45));
    }, function (t, n, r) {
      var e = r(0),
          o = r(22),
          i = r(4),
          c = r(27),
          u = r(28),
          a = r(46),
          f = o("wks"),
          s = e.Symbol,
          p = a ? s : s && s.withoutSetter || c;

      t.exports = function (t) {
        return i(f, t) || (u && i(s, t) ? f[t] = s[t] : f[t] = p("Symbol." + t)), f[t];
      };
    }, function (t, n) {
      t.exports = function (t) {
        try {
          return !!t();
        } catch (t) {
          return !0;
        }
      };
    }, function (t, n) {
      t.exports = function (t) {
        return "object" == _typeof(t) ? null !== t : "function" == typeof t;
      };
    }, function (t, n) {
      var r = {}.hasOwnProperty;

      t.exports = function (t, n) {
        return r.call(t, n);
      };
    }, function (t, n, r) {
      var e = r(3);

      t.exports = function (t) {
        if (!e(t)) throw TypeError(String(t) + " is not an object");
        return t;
      };
    }, function (t, n) {
      var r = {}.toString;

      t.exports = function (t) {
        return r.call(t).slice(8, -1);
      };
    }, function (t, n, r) {
      var e = r(2);
      t.exports = !e(function () {
        return 7 != Object.defineProperty({}, 1, {
          get: function get() {
            return 7;
          }
        })[1];
      });
    }, function (t, n, r) {
      var e = r(7),
          o = r(25),
          i = r(5),
          c = r(15),
          u = Object.defineProperty;
      n.f = e ? u : function (t, n, r) {
        if (i(t), n = c(n, !0), i(r), o) try {
          return u(t, n, r);
        } catch (t) {}
        if ("get" in r || "set" in r) throw TypeError("Accessors not supported");
        return "value" in r && (t[n] = r.value), t;
      };
    }, function (t, n, r) {
      var e = r(55),
          o = r(0),
          i = function i(t) {
        return "function" == typeof t ? t : void 0;
      };

      t.exports = function (t, n) {
        return arguments.length < 2 ? i(e[t]) || i(o[t]) : e[t] && e[t][n] || o[t] && o[t][n];
      };
    }, function (t, n, r) {
      var e = r(7),
          o = r(8),
          i = r(16);
      t.exports = e ? function (t, n, r) {
        return o.f(t, n, i(1, r));
      } : function (t, n, r) {
        return t[n] = r, t;
      };
    }, function (t, n, r) {
      var e = r(0),
          o = r(10),
          i = r(4),
          c = r(14),
          u = r(17),
          a = r(29),
          f = a.get,
          s = a.enforce,
          p = String(String).split("String");
      (t.exports = function (t, n, r, u) {
        var a = !!u && !!u.unsafe,
            f = !!u && !!u.enumerable,
            l = !!u && !!u.noTargetGet;
        "function" == typeof r && ("string" != typeof n || i(r, "name") || o(r, "name", n), s(r).source = p.join("string" == typeof n ? n : "")), t !== e ? (a ? !l && t[n] && (f = !0) : delete t[n], f ? t[n] = r : o(t, n, r)) : f ? t[n] = r : c(n, r);
      })(Function.prototype, "toString", function () {
        return "function" == typeof this && f(this).source || u(this);
      });
    }, function (t, n) {
      t.exports = function (t) {
        if ("function" != typeof t) throw TypeError(String(t) + " is not a function");
        return t;
      };
    }, function (t, n, r) {
      var e = {};
      e[r(1)("toStringTag")] = "z", t.exports = "[object z]" === String(e);
    }, function (t, n, r) {
      var e = r(0),
          o = r(10);

      t.exports = function (t, n) {
        try {
          o(e, t, n);
        } catch (r) {
          e[t] = n;
        }

        return n;
      };
    }, function (t, n, r) {
      var e = r(3);

      t.exports = function (t, n) {
        if (!e(t)) return t;
        var r, o;
        if (n && "function" == typeof (r = t.toString) && !e(o = r.call(t))) return o;
        if ("function" == typeof (r = t.valueOf) && !e(o = r.call(t))) return o;
        if (!n && "function" == typeof (r = t.toString) && !e(o = r.call(t))) return o;
        throw TypeError("Can't convert object to primitive value");
      };
    }, function (t, n) {
      t.exports = function (t, n) {
        return {
          enumerable: !(1 & t),
          configurable: !(2 & t),
          writable: !(4 & t),
          value: n
        };
      };
    }, function (t, n, r) {
      var e = r(24),
          o = Function.toString;
      "function" != typeof e.inspectSource && (e.inspectSource = function (t) {
        return o.call(t);
      }), t.exports = e.inspectSource;
    }, function (t, n, r) {
      var e = r(7),
          o = r(51),
          i = r(16),
          c = r(19),
          u = r(15),
          a = r(4),
          f = r(25),
          s = Object.getOwnPropertyDescriptor;
      n.f = e ? s : function (t, n) {
        if (t = c(t), n = u(n, !0), f) try {
          return s(t, n);
        } catch (t) {}
        if (a(t, n)) return i(!o.f.call(t, n), t[n]);
      };
    }, function (t, n, r) {
      var e = r(52),
          o = r(33);

      t.exports = function (t) {
        return e(o(t));
      };
    }, function (t, n, r) {
      var e = r(34),
          o = Math.min;

      t.exports = function (t) {
        return t > 0 ? o(e(t), 9007199254740991) : 0;
      };
    }, function (t, n, r) {
      var e,
          o,
          i = r(0),
          c = r(40),
          u = i.process,
          a = u && u.versions,
          f = a && a.v8;
      f ? o = (e = f.split("."))[0] + e[1] : c && (!(e = c.match(/Edge\/(\d+)/)) || e[1] >= 74) && (e = c.match(/Chrome\/(\d+)/)) && (o = e[1]), t.exports = o && +o;
    }, function (t, n, r) {
      var e = r(23),
          o = r(24);
      (t.exports = function (t, n) {
        return o[t] || (o[t] = void 0 !== n ? n : {});
      })("versions", []).push({
        version: "3.6.5",
        mode: e ? "pure" : "global",
        copyright: "© 2020 Denis Pushkarev (zloirock.ru)"
      });
    }, function (t, n) {
      t.exports = !1;
    }, function (t, n, r) {
      var e = r(0),
          o = r(14),
          i = e["__core-js_shared__"] || o("__core-js_shared__", {});
      t.exports = i;
    }, function (t, n, r) {
      var e = r(7),
          o = r(2),
          i = r(26);
      t.exports = !e && !o(function () {
        return 7 != Object.defineProperty(i("div"), "a", {
          get: function get() {
            return 7;
          }
        }).a;
      });
    }, function (t, n, r) {
      var e = r(0),
          o = r(3),
          i = e.document,
          c = o(i) && o(i.createElement);

      t.exports = function (t) {
        return c ? i.createElement(t) : {};
      };
    }, function (t, n) {
      var r = 0,
          e = Math.random();

      t.exports = function (t) {
        return "Symbol(" + String(void 0 === t ? "" : t) + ")_" + (++r + e).toString(36);
      };
    }, function (t, n, r) {
      var e = r(2);
      t.exports = !!Object.getOwnPropertySymbols && !e(function () {
        return !String(Symbol());
      });
    }, function (t, n, r) {
      var e,
          o,
          i,
          c = r(47),
          u = r(0),
          a = r(3),
          f = r(10),
          s = r(4),
          p = r(48),
          l = r(30),
          v = u.WeakMap;

      if (c) {
        var y = new v(),
            d = y.get,
            h = y.has,
            m = y.set;
        e = function e(t, n) {
          return m.call(y, t, n), n;
        }, o = function o(t) {
          return d.call(y, t) || {};
        }, i = function i(t) {
          return h.call(y, t);
        };
      } else {
        var g = p("state");
        l[g] = !0, e = function e(t, n) {
          return f(t, g, n), n;
        }, o = function o(t) {
          return s(t, g) ? t[g] : {};
        }, i = function i(t) {
          return s(t, g);
        };
      }

      t.exports = {
        set: e,
        get: o,
        has: i,
        enforce: function enforce(t) {
          return i(t) ? o(t) : e(t, {});
        },
        getterFor: function getterFor(t) {
          return function (n) {
            var r;
            if (!a(n) || (r = o(n)).type !== t) throw TypeError("Incompatible receiver, " + t + " required");
            return r;
          };
        }
      };
    }, function (t, n) {
      t.exports = {};
    }, function (t, n, r) {
      var e = r(13),
          o = r(6),
          i = r(1)("toStringTag"),
          c = "Arguments" == o(function () {
        return arguments;
      }());
      t.exports = e ? o : function (t) {
        var n, r, e;
        return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (r = function (t, n) {
          try {
            return t[n];
          } catch (t) {}
        }(n = Object(t), i)) ? r : c ? o(n) : "Object" == (e = o(n)) && "function" == typeof n.callee ? "Arguments" : e;
      };
    }, function (t, n, r) {
      var e = r(0),
          o = r(18).f,
          i = r(10),
          c = r(11),
          u = r(14),
          a = r(53),
          f = r(35);

      t.exports = function (t, n) {
        var r,
            s,
            p,
            l,
            v,
            y = t.target,
            d = t.global,
            h = t.stat;
        if (r = d ? e : h ? e[y] || u(y, {}) : (e[y] || {}).prototype) for (s in n) {
          if (l = n[s], p = t.noTargetGet ? (v = o(r, s)) && v.value : r[s], !f(d ? s : y + (h ? "." : "#") + s, t.forced) && void 0 !== p) {
            if (_typeof(l) == _typeof(p)) continue;
            a(l, p);
          }

          (t.sham || p && p.sham) && i(l, "sham", !0), c(r, s, l, t);
        }
      };
    }, function (t, n) {
      t.exports = function (t) {
        if (null == t) throw TypeError("Can't call method on " + t);
        return t;
      };
    }, function (t, n) {
      var r = Math.ceil,
          e = Math.floor;

      t.exports = function (t) {
        return isNaN(t = +t) ? 0 : (t > 0 ? e : r)(t);
      };
    }, function (t, n, r) {
      var e = r(2),
          o = /#|\.prototype\./,
          i = function i(t, n) {
        var r = u[c(t)];
        return r == f || r != a && ("function" == typeof n ? e(n) : !!n);
      },
          c = i.normalize = function (t) {
        return String(t).replace(o, ".").toLowerCase();
      },
          u = i.data = {},
          a = i.NATIVE = "N",
          f = i.POLYFILL = "P";

      t.exports = i;
    }, function (t, n) {
      t.exports = {};
    }, function (t, n, r) {
      var e = r(12);

      t.exports = function (t, n, r) {
        if (e(t), void 0 === n) return t;

        switch (r) {
          case 0:
            return function () {
              return t.call(n);
            };

          case 1:
            return function (r) {
              return t.call(n, r);
            };

          case 2:
            return function (r, e) {
              return t.call(n, r, e);
            };

          case 3:
            return function (r, e, o) {
              return t.call(n, r, e, o);
            };
        }

        return function () {
          return t.apply(n, arguments);
        };
      };
    }, function (t, n, r) {
      var e,
          o,
          i,
          c = r(0),
          u = r(2),
          a = r(6),
          f = r(37),
          s = r(73),
          p = r(26),
          l = r(39),
          v = c.location,
          y = c.setImmediate,
          d = c.clearImmediate,
          h = c.process,
          m = c.MessageChannel,
          g = c.Dispatch,
          x = 0,
          b = {},
          O = function O(t) {
        if (b.hasOwnProperty(t)) {
          var n = b[t];
          delete b[t], n();
        }
      },
          S = function S(t) {
        return function () {
          O(t);
        };
      },
          w = function w(t) {
        O(t.data);
      },
          j = function j(t) {
        c.postMessage(t + "", v.protocol + "//" + v.host);
      };

      y && d || (y = function y(t) {
        for (var n = [], r = 1; arguments.length > r;) {
          n.push(arguments[r++]);
        }

        return b[++x] = function () {
          ("function" == typeof t ? t : Function(t)).apply(void 0, n);
        }, e(x), x;
      }, d = function d(t) {
        delete b[t];
      }, "process" == a(h) ? e = function e(t) {
        h.nextTick(S(t));
      } : g && g.now ? e = function e(t) {
        g.now(S(t));
      } : m && !l ? (i = (o = new m()).port2, o.port1.onmessage = w, e = f(i.postMessage, i, 1)) : !c.addEventListener || "function" != typeof postMessage || c.importScripts || u(j) || "file:" === v.protocol ? e = "onreadystatechange" in p("script") ? function (t) {
        s.appendChild(p("script")).onreadystatechange = function () {
          s.removeChild(this), O(t);
        };
      } : function (t) {
        setTimeout(S(t), 0);
      } : (e = j, c.addEventListener("message", w, !1))), t.exports = {
        set: y,
        clear: d
      };
    }, function (t, n, r) {
      var e = r(40);
      t.exports = /(iphone|ipod|ipad).*applewebkit/i.test(e);
    }, function (t, n, r) {
      var e = r(9);
      t.exports = e("navigator", "userAgent") || "";
    }, function (t, n, r) {
      "use strict";

      var e = r(12),
          o = function o(t) {
        var n, r;
        this.promise = new t(function (t, e) {
          if (void 0 !== n || void 0 !== r) throw TypeError("Bad Promise constructor");
          n = t, r = e;
        }), this.resolve = e(n), this.reject = e(r);
      };

      t.exports.f = function (t) {
        return new o(t);
      };
    }, function (t, n, r) {
      var e = r(6);

      t.exports = Array.isArray || function (t) {
        return "Array" == e(t);
      };
    }, function (t, n) {
      function r(t, n) {
        t.onload = function () {
          this.onerror = this.onload = null, n(null, t);
        }, t.onerror = function () {
          this.onerror = this.onload = null, n(new Error("Failed to load " + this.src), t);
        };
      }

      function e(t, n) {
        t.onreadystatechange = function () {
          "complete" != this.readyState && "loaded" != this.readyState || (this.onreadystatechange = null, n(null, t));
        };
      }

      t.exports = function (t, n, o) {
        var i = document.head || document.getElementsByTagName("head")[0],
            c = document.createElement("script");
        "function" == typeof n && (o = n, n = {}), n = n || {}, o = o || function () {}, c.type = n.type || "text/javascript", c.charset = n.charset || "utf8", c.async = !("async" in n) || !!n.async, c.src = t, n.attrs && function (t, n) {
          for (var r in n) {
            t.setAttribute(r, n[r]);
          }
        }(c, n.attrs), n.text && (c.text = "" + n.text), ("onload" in c ? r : e)(c, o), c.onload || r(c, o), i.appendChild(c);
      };
    }, function (t, n, r) {
      var e = r(13),
          o = r(11),
          i = r(49);
      e || o(Object.prototype, "toString", i, {
        unsafe: !0
      });
    }, function (t, n) {
      var r;

      r = function () {
        return this;
      }();

      try {
        r = r || new Function("return this")();
      } catch (t) {
        "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (r = window);
      }

      t.exports = r;
    }, function (t, n, r) {
      var e = r(28);
      t.exports = e && !Symbol.sham && "symbol" == _typeof(Symbol.iterator);
    }, function (t, n, r) {
      var e = r(0),
          o = r(17),
          i = e.WeakMap;
      t.exports = "function" == typeof i && /native code/.test(o(i));
    }, function (t, n, r) {
      var e = r(22),
          o = r(27),
          i = e("keys");

      t.exports = function (t) {
        return i[t] || (i[t] = o(t));
      };
    }, function (t, n, r) {
      "use strict";

      var e = r(13),
          o = r(31);
      t.exports = e ? {}.toString : function () {
        return "[object " + o(this) + "]";
      };
    }, function (t, n, r) {
      "use strict";

      var e,
          o,
          i,
          c,
          u = r(32),
          a = r(23),
          f = r(0),
          s = r(9),
          p = r(62),
          l = r(11),
          v = r(63),
          y = r(64),
          d = r(65),
          h = r(3),
          m = r(12),
          g = r(66),
          x = r(6),
          b = r(17),
          O = r(67),
          S = r(71),
          w = r(72),
          j = r(38).set,
          E = r(74),
          T = r(75),
          P = r(76),
          _ = r(41),
          L = r(77),
          M = r(29),
          C = r(35),
          k = r(1),
          R = r(21),
          A = k("species"),
          D = "Promise",
          I = M.get,
          N = M.set,
          F = M.getterFor(D),
          _W = p,
          K = f.TypeError,
          H = f.document,
          G = f.process,
          U = s("fetch"),
          V = _.f,
          z = V,
          B = "process" == x(G),
          q = !!(H && H.createEvent && f.dispatchEvent),
          Y = C(D, function () {
        if (b(_W) === String(_W)) {
          if (66 === R) return !0;
          if (!B && "function" != typeof PromiseRejectionEvent) return !0;
        }

        if (a && !_W.prototype.finally) return !0;
        if (R >= 51 && /native code/.test(_W)) return !1;

        var t = _W.resolve(1),
            n = function n(t) {
          t(function () {}, function () {});
        };

        return (t.constructor = {})[A] = n, !(t.then(function () {}) instanceof n);
      }),
          J = Y || !S(function (t) {
        _W.all(t).catch(function () {});
      }),
          Q = function Q(t) {
        var n;
        return !(!h(t) || "function" != typeof (n = t.then)) && n;
      },
          X = function X(t, n, r) {
        if (!n.notified) {
          n.notified = !0;
          var e = n.reactions;
          E(function () {
            for (var o = n.value, i = 1 == n.state, c = 0; e.length > c;) {
              var u,
                  a,
                  f,
                  s = e[c++],
                  p = i ? s.ok : s.fail,
                  l = s.resolve,
                  v = s.reject,
                  y = s.domain;

              try {
                p ? (i || (2 === n.rejection && nt(t, n), n.rejection = 1), !0 === p ? u = o : (y && y.enter(), u = p(o), y && (y.exit(), f = !0)), u === s.promise ? v(K("Promise-chain cycle")) : (a = Q(u)) ? a.call(u, l, v) : l(u)) : v(o);
              } catch (t) {
                y && !f && y.exit(), v(t);
              }
            }

            n.reactions = [], n.notified = !1, r && !n.rejection && $(t, n);
          });
        }
      },
          Z = function Z(t, n, r) {
        var e, o;
        q ? ((e = H.createEvent("Event")).promise = n, e.reason = r, e.initEvent(t, !1, !0), f.dispatchEvent(e)) : e = {
          promise: n,
          reason: r
        }, (o = f["on" + t]) ? o(e) : "unhandledrejection" === t && P("Unhandled promise rejection", r);
      },
          $ = function $(t, n) {
        j.call(f, function () {
          var r,
              e = n.value;
          if (tt(n) && (r = L(function () {
            B ? G.emit("unhandledRejection", e, t) : Z("unhandledrejection", t, e);
          }), n.rejection = B || tt(n) ? 2 : 1, r.error)) throw r.value;
        });
      },
          tt = function tt(t) {
        return 1 !== t.rejection && !t.parent;
      },
          nt = function nt(t, n) {
        j.call(f, function () {
          B ? G.emit("rejectionHandled", t) : Z("rejectionhandled", t, n.value);
        });
      },
          rt = function rt(t, n, r, e) {
        return function (o) {
          t(n, r, o, e);
        };
      },
          et = function et(t, n, r, e) {
        n.done || (n.done = !0, e && (n = e), n.value = r, n.state = 2, X(t, n, !0));
      },
          ot = function ot(t, n, r, e) {
        if (!n.done) {
          n.done = !0, e && (n = e);

          try {
            if (t === r) throw K("Promise can't be resolved itself");
            var o = Q(r);
            o ? E(function () {
              var e = {
                done: !1
              };

              try {
                o.call(r, rt(ot, t, e, n), rt(et, t, e, n));
              } catch (r) {
                et(t, e, r, n);
              }
            }) : (n.value = r, n.state = 1, X(t, n, !1));
          } catch (r) {
            et(t, {
              done: !1
            }, r, n);
          }
        }
      };

      Y && (_W = function W(t) {
        g(this, _W, D), m(t), e.call(this);
        var n = I(this);

        try {
          t(rt(ot, this, n), rt(et, this, n));
        } catch (t) {
          et(this, n, t);
        }
      }, (e = function e(t) {
        N(this, {
          type: D,
          done: !1,
          notified: !1,
          parent: !1,
          reactions: [],
          rejection: !1,
          state: 0,
          value: void 0
        });
      }).prototype = v(_W.prototype, {
        then: function then(t, n) {
          var r = F(this),
              e = V(w(this, _W));
          return e.ok = "function" != typeof t || t, e.fail = "function" == typeof n && n, e.domain = B ? G.domain : void 0, r.parent = !0, r.reactions.push(e), 0 != r.state && X(this, r, !1), e.promise;
        },
        catch: function _catch(t) {
          return this.then(void 0, t);
        }
      }), o = function o() {
        var t = new e(),
            n = I(t);
        this.promise = t, this.resolve = rt(ot, t, n), this.reject = rt(et, t, n);
      }, _.f = V = function V(t) {
        return t === _W || t === i ? new o(t) : z(t);
      }, a || "function" != typeof p || (c = p.prototype.then, l(p.prototype, "then", function (t, n) {
        var r = this;
        return new _W(function (t, n) {
          c.call(r, t, n);
        }).then(t, n);
      }, {
        unsafe: !0
      }), "function" == typeof U && u({
        global: !0,
        enumerable: !0,
        forced: !0
      }, {
        fetch: function fetch(t) {
          return T(_W, U.apply(f, arguments));
        }
      }))), u({
        global: !0,
        wrap: !0,
        forced: Y
      }, {
        Promise: _W
      }), y(_W, D, !1, !0), d(D), i = s(D), u({
        target: D,
        stat: !0,
        forced: Y
      }, {
        reject: function reject(t) {
          var n = V(this);
          return n.reject.call(void 0, t), n.promise;
        }
      }), u({
        target: D,
        stat: !0,
        forced: a || Y
      }, {
        resolve: function resolve(t) {
          return T(a && this === i ? _W : this, t);
        }
      }), u({
        target: D,
        stat: !0,
        forced: J
      }, {
        all: function all(t) {
          var n = this,
              r = V(n),
              e = r.resolve,
              o = r.reject,
              i = L(function () {
            var r = m(n.resolve),
                i = [],
                c = 0,
                u = 1;
            O(t, function (t) {
              var a = c++,
                  f = !1;
              i.push(void 0), u++, r.call(n, t).then(function (t) {
                f || (f = !0, i[a] = t, --u || e(i));
              }, o);
            }), --u || e(i);
          });
          return i.error && o(i.value), r.promise;
        },
        race: function race(t) {
          var n = this,
              r = V(n),
              e = r.reject,
              o = L(function () {
            var o = m(n.resolve);
            O(t, function (t) {
              o.call(n, t).then(r.resolve, e);
            });
          });
          return o.error && e(o.value), r.promise;
        }
      });
    }, function (t, n, r) {
      "use strict";

      var e = {}.propertyIsEnumerable,
          o = Object.getOwnPropertyDescriptor,
          i = o && !e.call({
        1: 2
      }, 1);
      n.f = i ? function (t) {
        var n = o(this, t);
        return !!n && n.enumerable;
      } : e;
    }, function (t, n, r) {
      var e = r(2),
          o = r(6),
          i = "".split;
      t.exports = e(function () {
        return !Object("z").propertyIsEnumerable(0);
      }) ? function (t) {
        return "String" == o(t) ? i.call(t, "") : Object(t);
      } : Object;
    }, function (t, n, r) {
      var e = r(4),
          o = r(54),
          i = r(18),
          c = r(8);

      t.exports = function (t, n) {
        for (var r = o(n), u = c.f, a = i.f, f = 0; f < r.length; f++) {
          var s = r[f];
          e(t, s) || u(t, s, a(n, s));
        }
      };
    }, function (t, n, r) {
      var e = r(9),
          o = r(56),
          i = r(61),
          c = r(5);

      t.exports = e("Reflect", "ownKeys") || function (t) {
        var n = o.f(c(t)),
            r = i.f;
        return r ? n.concat(r(t)) : n;
      };
    }, function (t, n, r) {
      var e = r(0);
      t.exports = e;
    }, function (t, n, r) {
      var e = r(57),
          o = r(60).concat("length", "prototype");

      n.f = Object.getOwnPropertyNames || function (t) {
        return e(t, o);
      };
    }, function (t, n, r) {
      var e = r(4),
          o = r(19),
          i = r(58).indexOf,
          c = r(30);

      t.exports = function (t, n) {
        var r,
            u = o(t),
            a = 0,
            f = [];

        for (r in u) {
          !e(c, r) && e(u, r) && f.push(r);
        }

        for (; n.length > a;) {
          e(u, r = n[a++]) && (~i(f, r) || f.push(r));
        }

        return f;
      };
    }, function (t, n, r) {
      var e = r(19),
          o = r(20),
          i = r(59),
          c = function c(t) {
        return function (n, r, c) {
          var u,
              a = e(n),
              f = o(a.length),
              s = i(c, f);

          if (t && r != r) {
            for (; f > s;) {
              if ((u = a[s++]) != u) return !0;
            }
          } else for (; f > s; s++) {
            if ((t || s in a) && a[s] === r) return t || s || 0;
          }

          return !t && -1;
        };
      };

      t.exports = {
        includes: c(!0),
        indexOf: c(!1)
      };
    }, function (t, n, r) {
      var e = r(34),
          o = Math.max,
          i = Math.min;

      t.exports = function (t, n) {
        var r = e(t);
        return r < 0 ? o(r + n, 0) : i(r, n);
      };
    }, function (t, n) {
      t.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
    }, function (t, n) {
      n.f = Object.getOwnPropertySymbols;
    }, function (t, n, r) {
      var e = r(0);
      t.exports = e.Promise;
    }, function (t, n, r) {
      var e = r(11);

      t.exports = function (t, n, r) {
        for (var o in n) {
          e(t, o, n[o], r);
        }

        return t;
      };
    }, function (t, n, r) {
      var e = r(8).f,
          o = r(4),
          i = r(1)("toStringTag");

      t.exports = function (t, n, r) {
        t && !o(t = r ? t : t.prototype, i) && e(t, i, {
          configurable: !0,
          value: n
        });
      };
    }, function (t, n, r) {
      "use strict";

      var e = r(9),
          o = r(8),
          i = r(1),
          c = r(7),
          u = i("species");

      t.exports = function (t) {
        var n = e(t),
            r = o.f;
        c && n && !n[u] && r(n, u, {
          configurable: !0,
          get: function get() {
            return this;
          }
        });
      };
    }, function (t, n) {
      t.exports = function (t, n, r) {
        if (!(t instanceof n)) throw TypeError("Incorrect " + (r ? r + " " : "") + "invocation");
        return t;
      };
    }, function (t, n, r) {
      var e = r(5),
          o = r(68),
          i = r(20),
          c = r(37),
          u = r(69),
          a = r(70),
          f = function f(t, n) {
        this.stopped = t, this.result = n;
      };

      (t.exports = function (t, n, r, s, p) {
        var l,
            v,
            y,
            d,
            h,
            m,
            g,
            x = c(n, r, s ? 2 : 1);
        if (p) l = t;else {
          if ("function" != typeof (v = u(t))) throw TypeError("Target is not iterable");

          if (o(v)) {
            for (y = 0, d = i(t.length); d > y; y++) {
              if ((h = s ? x(e(g = t[y])[0], g[1]) : x(t[y])) && h instanceof f) return h;
            }

            return new f(!1);
          }

          l = v.call(t);
        }

        for (m = l.next; !(g = m.call(l)).done;) {
          if ("object" == _typeof(h = a(l, x, g.value, s)) && h && h instanceof f) return h;
        }

        return new f(!1);
      }).stop = function (t) {
        return new f(!0, t);
      };
    }, function (t, n, r) {
      var e = r(1),
          o = r(36),
          i = e("iterator"),
          c = Array.prototype;

      t.exports = function (t) {
        return void 0 !== t && (o.Array === t || c[i] === t);
      };
    }, function (t, n, r) {
      var e = r(31),
          o = r(36),
          i = r(1)("iterator");

      t.exports = function (t) {
        if (null != t) return t[i] || t["@@iterator"] || o[e(t)];
      };
    }, function (t, n, r) {
      var e = r(5);

      t.exports = function (t, n, r, o) {
        try {
          return o ? n(e(r)[0], r[1]) : n(r);
        } catch (n) {
          var i = t.return;
          throw void 0 !== i && e(i.call(t)), n;
        }
      };
    }, function (t, n, r) {
      var e = r(1)("iterator"),
          o = !1;

      try {
        var i = 0,
            c = {
          next: function next() {
            return {
              done: !!i++
            };
          },
          return: function _return() {
            o = !0;
          }
        };
        c[e] = function () {
          return this;
        }, Array.from(c, function () {
          throw 2;
        });
      } catch (t) {}

      t.exports = function (t, n) {
        if (!n && !o) return !1;
        var r = !1;

        try {
          var i = {};
          i[e] = function () {
            return {
              next: function next() {
                return {
                  done: r = !0
                };
              }
            };
          }, t(i);
        } catch (t) {}

        return r;
      };
    }, function (t, n, r) {
      var e = r(5),
          o = r(12),
          i = r(1)("species");

      t.exports = function (t, n) {
        var r,
            c = e(t).constructor;
        return void 0 === c || null == (r = e(c)[i]) ? n : o(r);
      };
    }, function (t, n, r) {
      var e = r(9);
      t.exports = e("document", "documentElement");
    }, function (t, n, r) {
      var e,
          o,
          i,
          c,
          u,
          a,
          f,
          s,
          p = r(0),
          l = r(18).f,
          v = r(6),
          y = r(38).set,
          d = r(39),
          h = p.MutationObserver || p.WebKitMutationObserver,
          m = p.process,
          g = p.Promise,
          x = "process" == v(m),
          b = l(p, "queueMicrotask"),
          O = b && b.value;
      O || (e = function e() {
        var t, n;

        for (x && (t = m.domain) && t.exit(); o;) {
          n = o.fn, o = o.next;

          try {
            n();
          } catch (t) {
            throw o ? c() : i = void 0, t;
          }
        }

        i = void 0, t && t.enter();
      }, x ? c = function c() {
        m.nextTick(e);
      } : h && !d ? (u = !0, a = document.createTextNode(""), new h(e).observe(a, {
        characterData: !0
      }), c = function c() {
        a.data = u = !u;
      }) : g && g.resolve ? (f = g.resolve(void 0), s = f.then, c = function c() {
        s.call(f, e);
      }) : c = function c() {
        y.call(p, e);
      }), t.exports = O || function (t) {
        var n = {
          fn: t,
          next: void 0
        };
        i && (i.next = n), o || (o = n, c()), i = n;
      };
    }, function (t, n, r) {
      var e = r(5),
          o = r(3),
          i = r(41);

      t.exports = function (t, n) {
        if (e(t), o(n) && n.constructor === t) return n;
        var r = i.f(t);
        return (0, r.resolve)(n), r.promise;
      };
    }, function (t, n, r) {
      var e = r(0);

      t.exports = function (t, n) {
        var r = e.console;
        r && r.error && (1 === arguments.length ? r.error(t) : r.error(t, n));
      };
    }, function (t, n) {
      t.exports = function (t) {
        try {
          return {
            error: !1,
            value: t()
          };
        } catch (t) {
          return {
            error: !0,
            value: t
          };
        }
      };
    }, function (t, n, r) {
      "use strict";

      var e = r(32),
          o = r(2),
          i = r(42),
          c = r(3),
          u = r(79),
          a = r(20),
          f = r(80),
          s = r(81),
          p = r(82),
          l = r(1),
          v = r(21),
          y = l("isConcatSpreadable"),
          d = v >= 51 || !o(function () {
        var t = [];
        return t[y] = !1, t.concat()[0] !== t;
      }),
          h = p("concat"),
          m = function m(t) {
        if (!c(t)) return !1;
        var n = t[y];
        return void 0 !== n ? !!n : i(t);
      };

      e({
        target: "Array",
        proto: !0,
        forced: !d || !h
      }, {
        concat: function concat(t) {
          var n,
              r,
              e,
              o,
              i,
              c = u(this),
              p = s(c, 0),
              l = 0;

          for (n = -1, e = arguments.length; n < e; n++) {
            if (m(i = -1 === n ? c : arguments[n])) {
              if (l + (o = a(i.length)) > 9007199254740991) throw TypeError("Maximum allowed index exceeded");

              for (r = 0; r < o; r++, l++) {
                r in i && f(p, l, i[r]);
              }
            } else {
              if (l >= 9007199254740991) throw TypeError("Maximum allowed index exceeded");
              f(p, l++, i);
            }
          }

          return p.length = l, p;
        }
      });
    }, function (t, n, r) {
      var e = r(33);

      t.exports = function (t) {
        return Object(e(t));
      };
    }, function (t, n, r) {
      "use strict";

      var e = r(15),
          o = r(8),
          i = r(16);

      t.exports = function (t, n, r) {
        var c = e(n);
        c in t ? o.f(t, c, i(0, r)) : t[c] = r;
      };
    }, function (t, n, r) {
      var e = r(3),
          o = r(42),
          i = r(1)("species");

      t.exports = function (t, n) {
        var r;
        return o(t) && ("function" != typeof (r = t.constructor) || r !== Array && !o(r.prototype) ? e(r) && null === (r = r[i]) && (r = void 0) : r = void 0), new (void 0 === r ? Array : r)(0 === n ? 0 : n);
      };
    }, function (t, n, r) {
      var e = r(2),
          o = r(1),
          i = r(21),
          c = o("species");

      t.exports = function (t) {
        return i >= 51 || !e(function () {
          var n = [];
          return (n.constructor = {})[c] = function () {
            return {
              foo: 1
            };
          }, 1 !== n[t](Boolean).foo;
        });
      };
    }, function (t, n, r) {
      "use strict";

      r.r(n), r.d(n, "getEditorNamespace", function () {
        return c;
      }), r.d(n, "debounce", function () {
        return u;
      }), r(44), r(50);
      var e,
          o = r(43),
          i = r.n(o);

      function c(t, n) {
        return "CKEDITOR" in window ? Promise.resolve(CKEDITOR) : t.length < 1 ? Promise.reject(new TypeError("CKEditor URL must be a non-empty string.")) : (e || (e = c.scriptLoader(t).then(function (t) {
          return n && n(t), t;
        })), e);
      }

      c.scriptLoader = function (t) {
        return new Promise(function (n, r) {
          i()(t, function (t) {
            return e = void 0, t ? r(t) : window.CKEDITOR ? void n(CKEDITOR) : r(new Error("Script loaded from editorUrl doesn't provide CKEDITOR namespace."));
          });
        });
      }, r(78);

      var u = function u(t, n) {
        var r,
            e = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        return function () {
          clearTimeout(r);

          for (var o = arguments.length, i = new Array(o), c = 0; c < o; c++) {
            i[c] = arguments[c];
          }

          r = setTimeout(t.bind.apply(t, [e].concat(i)), n);
        };
      };
    }]));
  }, function (t, n, r) {
    "use strict";

    r.r(n);
    r(42), r(61), r(67), r(68), r(70), r(72), r(75), r(79);
    var e = r(21),
        o = r.n(e),
        i = r(2),
        c = r.n(i),
        u = r(40);

    function a(t) {
      return (a = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      })(t);
    }

    function f(t, n) {
      for (var r = 0; r < n.length; r++) {
        var e = n[r];
        e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(t, e.key, e);
      }
    }

    function s(t, n) {
      return (s = Object.setPrototypeOf || function (t, n) {
        return t.__proto__ = n, t;
      })(t, n);
    }

    function p(t) {
      var n = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var r,
            e = v(t);

        if (n) {
          var o = v(this).constructor;
          r = Reflect.construct(e, arguments, o);
        } else r = e.apply(this, arguments);

        return l(this, r);
      };
    }

    function l(t, n) {
      return !n || "object" !== a(n) && "function" != typeof n ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : n;
    }

    function v(t) {
      return (v = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var y = function (t) {
      !function (t, n) {
        if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(n && n.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), n && s(t, n);
      }(c, t);
      var n,
          r,
          e,
          i = p(c);

      function c(t) {
        var n;
        return function (t, n) {
          if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
        }(this, c), (n = i.call(this, t)).element = null, n.editor = null, n._destroyed = !1, n;
      }

      return n = c, (r = [{
        key: "componentDidMount",
        value: function value() {
          this._initEditor();
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this._destroyEditor();
        }
      }, {
        key: "componentDidUpdate",
        value: function value(t) {
          var n = this.props,
              r = this.editor;
          r && (t.data !== n.data && r.getData() !== n.data && r.setData(n.data), t.readOnly !== n.readOnly && r.setReadOnly(n.readOnly), t.style !== n.style && r.container.setStyles(n.style), this._attachEventHandlers(t));
        }
      }, {
        key: "render",
        value: function value() {
          var t = this;
          return o.a.createElement("div", {
            id: this.props.name,
            name: this.props.name,
            style: this.props.style,
            ref: function ref(n) {
              return t.element = n;
            }
          });
        }
      }, {
        key: "_initEditor",
        value: function value() {
          var t = this,
              n = this.props,
              r = n.config,
              e = n.readOnly,
              o = n.type,
              i = n.onBeforeLoad,
              a = n.onNamespaceLoaded,
              f = n.style,
              s = n.data;
          r.readOnly = e, Object(u.getEditorNamespace)(c.editorUrl, a).then(function (n) {
            if (!t._destroyed) {
              if (!t.element) throw new Error("Element not available for mounting CKEDITOR instance.");
              var c = "inline" === o ? "inline" : "replace";
              i && i(n);
              var u = t.editor = n[c](t.element, r);
              t._attachEventHandlers(), "inline" !== o || e || u.on("instanceReady", function () {
                u.setReadOnly(!1);
              }, null, null, -1), f && "inline" !== o && u.on("loaded", function () {
                u.container.setStyles(f);
              }), s && u.setData(s);
            }
          }).catch(console.error);
        }
      }, {
        key: "_attachEventHandlers",
        value: function value() {
          var t = this,
              n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              r = this.props;
          Object.keys(this.props).forEach(function (e) {
            e.startsWith("on") && n[e] !== r[e] && t._attachEventHandler(e, n[e]);
          });
        }
      }, {
        key: "_attachEventHandler",
        value: function value(t, n) {
          var r = "".concat(t[2].toLowerCase()).concat(t.substr(3));
          n && this.editor.removeListener(r, n), this.editor.on(r, this.props[t]);
        }
      }, {
        key: "_destroyEditor",
        value: function value() {
          this.editor && this.editor.destroy(), this.editor = null, this.element = null, this._destroyed = !0;
        }
      }]) && f(n.prototype, r), e && f(n, e), c;
    }(o.a.Component);

    y.propTypes = {
      type: c.a.oneOf(["classic", "inline"]),
      data: c.a.string,
      config: c.a.object,
      name: c.a.string,
      style: c.a.object,
      readOnly: c.a.bool,
      onBeforeLoad: c.a.func,
      onNamespaceLoaded: c.a.func
    }, y.defaultProps = {
      type: "classic",
      data: "",
      config: {},
      readOnly: !1
    }, y.editorUrl = "https://cdn.ckeditor.com/4.16.0/standard-all/ckeditor.js", y.displayName = "CKEditor", n.default = y;
  }, function (t, n, r) {
    "use strict";

    var e = r(5),
        o = r(1),
        i = r(34),
        c = r(3),
        u = r(8),
        a = r(11),
        f = r(57),
        s = r(35),
        p = r(59),
        l = r(9),
        v = r(37),
        y = l("isConcatSpreadable"),
        d = 9007199254740991,
        h = "Maximum allowed index exceeded",
        m = v >= 51 || !o(function () {
      var t = [];
      return t[y] = !1, t.concat()[0] !== t;
    }),
        g = p("concat"),
        x = function x(t) {
      if (!c(t)) return !1;
      var n = t[y];
      return void 0 !== n ? !!n : i(t);
    };

    e({
      target: "Array",
      proto: !0,
      forced: !m || !g
    }, {
      concat: function concat(t) {
        var n,
            r,
            e,
            o,
            i,
            c = u(this),
            p = s(c, 0),
            l = 0;

        for (n = -1, e = arguments.length; n < e; n++) {
          if (x(i = -1 === n ? c : arguments[n])) {
            if (l + (o = a(i.length)) > d) throw TypeError(h);

            for (r = 0; r < o; r++, l++) {
              r in i && f(p, l, i[r]);
            }
          } else {
            if (l >= d) throw TypeError(h);
            f(p, l++, i);
          }
        }

        return p.length = l, p;
      }
    });
  }, function (t, n) {
    var r;

    r = function () {
      return this;
    }();

    try {
      r = r || new Function("return this")();
    } catch (t) {
      "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (r = window);
    }

    t.exports = r;
  }, function (t, n, r) {
    "use strict";

    var e = {}.propertyIsEnumerable,
        o = Object.getOwnPropertyDescriptor,
        i = o && !e.call({
      1: 2
    }, 1);
    n.f = i ? function (t) {
      var n = o(this, t);
      return !!n && n.enumerable;
    } : e;
  }, function (t, n, r) {
    var e = r(0),
        o = r(3),
        i = e.document,
        c = o(i) && o(i.createElement);

    t.exports = function (t) {
      return c ? i.createElement(t) : {};
    };
  }, function (t, n, r) {
    var e = r(0),
        o = r(7),
        i = r(4),
        c = r(19),
        u = r(24),
        a = r(47),
        f = a.get,
        s = a.enforce,
        p = String(String).split("String");
    (t.exports = function (t, n, r, u) {
      var a,
          f = !!u && !!u.unsafe,
          l = !!u && !!u.enumerable,
          v = !!u && !!u.noTargetGet;
      "function" == typeof r && ("string" != typeof n || i(r, "name") || o(r, "name", n), (a = s(r)).source || (a.source = p.join("string" == typeof n ? n : ""))), t !== e ? (f ? !v && t[n] && (l = !0) : delete t[n], l ? t[n] = r : o(t, n, r)) : l ? t[n] = r : c(n, r);
    })(Function.prototype, "toString", function () {
      return "function" == typeof this && f(this).source || u(this);
    });
  }, function (t, n, r) {
    var e,
        o,
        i,
        c = r(48),
        u = r(0),
        a = r(3),
        f = r(7),
        s = r(4),
        p = r(20),
        l = r(25),
        v = r(29),
        y = u.WeakMap;

    if (c) {
      var d = p.state || (p.state = new y()),
          h = d.get,
          m = d.has,
          g = d.set;
      e = function e(t, n) {
        return n.facade = t, g.call(d, t, n), n;
      }, o = function o(t) {
        return h.call(d, t) || {};
      }, i = function i(t) {
        return m.call(d, t);
      };
    } else {
      var x = l("state");
      v[x] = !0, e = function e(t, n) {
        return n.facade = t, f(t, x, n), n;
      }, o = function o(t) {
        return s(t, x) ? t[x] : {};
      }, i = function i(t) {
        return s(t, x);
      };
    }

    t.exports = {
      set: e,
      get: o,
      has: i,
      enforce: function enforce(t) {
        return i(t) ? o(t) : e(t, {});
      },
      getterFor: function getterFor(t) {
        return function (n) {
          var r;
          if (!a(n) || (r = o(n)).type !== t) throw TypeError("Incompatible receiver, " + t + " required");
          return r;
        };
      }
    };
  }, function (t, n, r) {
    var e = r(0),
        o = r(24),
        i = e.WeakMap;
    t.exports = "function" == typeof i && /native code/.test(o(i));
  }, function (t, n, r) {
    var e = r(4),
        o = r(50),
        i = r(12),
        c = r(10);

    t.exports = function (t, n) {
      for (var r = o(n), u = c.f, a = i.f, f = 0; f < r.length; f++) {
        var s = r[f];
        e(t, s) || u(t, s, a(n, s));
      }
    };
  }, function (t, n, r) {
    var e = r(30),
        o = r(52),
        i = r(55),
        c = r(18);

    t.exports = e("Reflect", "ownKeys") || function (t) {
      var n = o.f(c(t)),
          r = i.f;
      return r ? n.concat(r(t)) : n;
    };
  }, function (t, n, r) {
    var e = r(0);
    t.exports = e;
  }, function (t, n, r) {
    var e = r(31),
        o = r(33).concat("length", "prototype");

    n.f = Object.getOwnPropertyNames || function (t) {
      return e(t, o);
    };
  }, function (t, n, r) {
    var e = r(14),
        o = r(11),
        i = r(54),
        c = function c(t) {
      return function (n, r, c) {
        var u,
            a = e(n),
            f = o(a.length),
            s = i(c, f);

        if (t && r != r) {
          for (; f > s;) {
            if ((u = a[s++]) != u) return !0;
          }
        } else for (; f > s; s++) {
          if ((t || s in a) && a[s] === r) return t || s || 0;
        }

        return !t && -1;
      };
    };

    t.exports = {
      includes: c(!0),
      indexOf: c(!1)
    };
  }, function (t, n, r) {
    var e = r(32),
        o = Math.max,
        i = Math.min;

    t.exports = function (t, n) {
      var r = e(t);
      return r < 0 ? o(r + n, 0) : i(r, n);
    };
  }, function (t, n) {
    n.f = Object.getOwnPropertySymbols;
  }, function (t, n, r) {
    var e = r(1),
        o = /#|\.prototype\./,
        i = function i(t, n) {
      var r = u[c(t)];
      return r == f || r != a && ("function" == typeof n ? e(n) : !!n);
    },
        c = i.normalize = function (t) {
      return String(t).replace(o, ".").toLowerCase();
    },
        u = i.data = {},
        a = i.NATIVE = "N",
        f = i.POLYFILL = "P";

    t.exports = i;
  }, function (t, n, r) {
    "use strict";

    var e = r(17),
        o = r(10),
        i = r(13);

    t.exports = function (t, n, r) {
      var c = e(n);
      c in t ? o.f(t, c, i(0, r)) : t[c] = r;
    };
  }, function (t, n, r) {
    var e = r(36);
    t.exports = e && !Symbol.sham && "symbol" == _typeof(Symbol.iterator);
  }, function (t, n, r) {
    var e = r(1),
        o = r(9),
        i = r(37),
        c = o("species");

    t.exports = function (t) {
      return i >= 51 || !e(function () {
        var n = [];
        return (n.constructor = {})[c] = function () {
          return {
            foo: 1
          };
        }, 1 !== n[t](Boolean).foo;
      });
    };
  }, function (t, n, r) {
    var e = r(30);
    t.exports = e("navigator", "userAgent") || "";
  }, function (t, n, r) {
    "use strict";

    var e = r(5),
        o = r(38);
    e({
      target: "Array",
      proto: !0,
      forced: [].forEach != o
    }, {
      forEach: o
    });
  }, function (t, n, r) {
    var e = r(63),
        o = r(22),
        i = r(8),
        c = r(11),
        u = r(35),
        a = [].push,
        f = function f(t) {
      var n = 1 == t,
          r = 2 == t,
          f = 3 == t,
          s = 4 == t,
          p = 6 == t,
          l = 7 == t,
          v = 5 == t || p;
      return function (y, d, h, m) {
        for (var g, x, b = i(y), O = o(b), S = e(d, h, 3), w = c(O.length), j = 0, E = m || u, T = n ? E(y, w) : r || l ? E(y, 0) : void 0; w > j; j++) {
          if ((v || j in O) && (x = S(g = O[j], j, b), t)) if (n) T[j] = x;else if (x) switch (t) {
            case 3:
              return !0;

            case 5:
              return g;

            case 6:
              return j;

            case 2:
              a.call(T, g);
          } else switch (t) {
            case 4:
              return !1;

            case 7:
              a.call(T, g);
          }
        }

        return p ? -1 : f || s ? s : T;
      };
    };

    t.exports = {
      forEach: f(0),
      map: f(1),
      filter: f(2),
      some: f(3),
      every: f(4),
      find: f(5),
      findIndex: f(6),
      filterOut: f(7)
    };
  }, function (t, n, r) {
    var e = r(64);

    t.exports = function (t, n, r) {
      if (e(t), void 0 === n) return t;

      switch (r) {
        case 0:
          return function () {
            return t.call(n);
          };

        case 1:
          return function (r) {
            return t.call(n, r);
          };

        case 2:
          return function (r, e) {
            return t.call(n, r, e);
          };

        case 3:
          return function (r, e, o) {
            return t.call(n, r, e, o);
          };
      }

      return function () {
        return t.apply(n, arguments);
      };
    };
  }, function (t, n) {
    t.exports = function (t) {
      if ("function" != typeof t) throw TypeError(String(t) + " is not a function");
      return t;
    };
  }, function (t, n, r) {
    "use strict";

    var e = r(1);

    t.exports = function (t, n) {
      var r = [][t];
      return !!r && e(function () {
        r.call(null, n || function () {
          throw 1;
        }, 1);
      });
    };
  }, function (t, n, r) {
    var e = r(6),
        o = r(1),
        i = r(4),
        c = Object.defineProperty,
        u = {},
        a = function a(t) {
      throw t;
    };

    t.exports = function (t, n) {
      if (i(u, t)) return u[t];
      n || (n = {});
      var r = [][t],
          f = !!i(n, "ACCESSORS") && n.ACCESSORS,
          s = i(n, 0) ? n[0] : a,
          p = i(n, 1) ? n[1] : void 0;
      return u[t] = !!r && !o(function () {
        if (f && !e) return !0;
        var t = {
          length: -1
        };
        f ? c(t, 1, {
          enumerable: !0,
          get: a
        }) : t[1] = 1, r.call(t, s, p);
      });
    };
  }, function (t, n, r) {
    var e = r(6),
        o = r(10).f,
        i = Function.prototype,
        c = i.toString,
        u = /^\s*function ([^ (]*)/,
        a = "name";
    e && !(a in i) && o(i, a, {
      configurable: !0,
      get: function get() {
        try {
          return c.call(this).match(u)[1];
        } catch (t) {
          return "";
        }
      }
    });
  }, function (t, n, r) {
    var e = r(5),
        o = r(1),
        i = r(8),
        c = r(69),
        u = r(39);
    e({
      target: "Object",
      stat: !0,
      forced: o(function () {
        c(1);
      }),
      sham: !u
    }, {
      getPrototypeOf: function getPrototypeOf(t) {
        return c(i(t));
      }
    });
  }, function (t, n, r) {
    var e = r(4),
        o = r(8),
        i = r(25),
        c = r(39),
        u = i("IE_PROTO"),
        a = Object.prototype;
    t.exports = c ? Object.getPrototypeOf : function (t) {
      return t = o(t), e(t, u) ? t[u] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? a : null;
    };
  }, function (t, n, r) {
    var e = r(5),
        o = r(8),
        i = r(71);
    e({
      target: "Object",
      stat: !0,
      forced: r(1)(function () {
        i(1);
      })
    }, {
      keys: function keys(t) {
        return i(o(t));
      }
    });
  }, function (t, n, r) {
    var e = r(31),
        o = r(33);

    t.exports = Object.keys || function (t) {
      return e(t, o);
    };
  }, function (t, n, r) {
    r(5)({
      target: "Object",
      stat: !0
    }, {
      setPrototypeOf: r(73)
    });
  }, function (t, n, r) {
    var e = r(18),
        o = r(74);
    t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function () {
      var t,
          n = !1,
          r = {};

      try {
        (t = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(r, []), n = r instanceof Array;
      } catch (t) {}

      return function (r, i) {
        return e(r), o(i), n ? t.call(r, i) : r.__proto__ = i, r;
      };
    }() : void 0);
  }, function (t, n, r) {
    var e = r(3);

    t.exports = function (t) {
      if (!e(t) && null !== t) throw TypeError("Can't set " + String(t) + " as a prototype");
      return t;
    };
  }, function (t, n, r) {
    "use strict";

    var e,
        o = r(5),
        i = r(12).f,
        c = r(11),
        u = r(76),
        a = r(16),
        f = r(78),
        s = r(27),
        p = "".startsWith,
        l = Math.min,
        v = f("startsWith");
    o({
      target: "String",
      proto: !0,
      forced: !!(s || v || (e = i(String.prototype, "startsWith"), !e || e.writable)) && !v
    }, {
      startsWith: function startsWith(t) {
        var n = String(a(this));
        u(t);
        var r = c(l(arguments.length > 1 ? arguments[1] : void 0, n.length)),
            e = String(t);
        return p ? p.call(n, e, r) : n.slice(r, r + e.length) === e;
      }
    });
  }, function (t, n, r) {
    var e = r(77);

    t.exports = function (t) {
      if (e(t)) throw TypeError("The method doesn't accept regular expressions");
      return t;
    };
  }, function (t, n, r) {
    var e = r(3),
        o = r(15),
        i = r(9)("match");

    t.exports = function (t) {
      var n;
      return e(t) && (void 0 !== (n = t[i]) ? !!n : "RegExp" == o(t));
    };
  }, function (t, n, r) {
    var e = r(9)("match");

    t.exports = function (t) {
      var n = /./;

      try {
        "/./"[t](n);
      } catch (r) {
        try {
          return n[e] = !1, "/./"[t](n);
        } catch (t) {}
      }

      return !1;
    };
  }, function (t, n, r) {
    var e = r(0),
        o = r(80),
        i = r(38),
        c = r(7);

    for (var u in o) {
      var a = e[u],
          f = a && a.prototype;
      if (f && f.forEach !== i) try {
        c(f, "forEach", i);
      } catch (t) {
        f.forEach = i;
      }
    }
  }, function (t, n) {
    t.exports = {
      CSSRuleList: 0,
      CSSStyleDeclaration: 0,
      CSSValueList: 0,
      ClientRectList: 0,
      DOMRectList: 0,
      DOMStringList: 0,
      DOMTokenList: 1,
      DataTransferItemList: 0,
      FileList: 0,
      HTMLAllCollection: 0,
      HTMLCollection: 0,
      HTMLFormElement: 0,
      HTMLSelectElement: 0,
      MediaList: 0,
      MimeTypeArray: 0,
      NamedNodeMap: 0,
      NodeList: 1,
      PaintRequestList: 0,
      Plugin: 0,
      PluginArray: 0,
      SVGLengthList: 0,
      SVGNumberList: 0,
      SVGPathSegList: 0,
      SVGPointList: 0,
      SVGStringList: 0,
      SVGTransformList: 0,
      SourceBufferList: 0,
      StyleSheetList: 0,
      TextTrackCueList: 0,
      TextTrackList: 0,
      TouchList: 0
    };
  }, function (t, n, r) {
    "use strict";

    var e = r(82);

    function o() {}

    function i() {}

    i.resetWarningCache = o, t.exports = function () {
      function t(t, n, r, o, i, c) {
        if (c !== e) {
          var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw u.name = "Invariant Violation", u;
        }
      }

      function n() {
        return t;
      }

      t.isRequired = t;
      var r = {
        array: t,
        bool: t,
        func: t,
        number: t,
        object: t,
        string: t,
        symbol: t,
        any: t,
        arrayOf: n,
        element: t,
        elementType: t,
        instanceOf: n,
        node: t,
        objectOf: n,
        oneOf: n,
        oneOfType: n,
        shape: n,
        exact: n,
        checkPropTypes: i,
        resetWarningCache: o
      };
      return r.PropTypes = r, r;
    };
  }, function (t, n, r) {
    "use strict";

    t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }]).default;
});